<div [@routerTransition]>
  <!--<div class="row row-style-card">
    <a (click)="AddNewPatient()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>Register</a>
    <a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>
  </div>-->
  <!--<a class="nav-link-hand new-button3" title="Back To Profile" (click)="BackToProfile()" *ngIf="Showarrow"><i class="fas fa-angle-double-left font-size-19px"></i> Back</a>-->
  <div class="card my-profile-form margin-top-15px top-link" *ngIf="ShowList">
    <div class="card-header wh-header padding-bottom-6px">
      <div class="row">
        <div class="col-md-3">
          Dept Consumption Entry
        </div>
        <div class="col-md-8 padding-right-0px">
          <div class="row">
            <div class="offset-md-3 col-md-2 padding-right-0px text-align-center">
              <a (click)="OpenBill()" class="nav-link-hand patientreg-link row-card-a margin-bottom-8px" title="Click here for New Registration" *ngIf="ShowRegister"><i class="fas fa-plus font-size-11 margin-right-3px"></i>New</a>
            </div>
            <div class="col-md-3 col-sm-3 padding-right padding-left-0px">
              <div class="form-group  margin-bottom-5px">
                <div class="row">
                  <div (click)="DecrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                    <a title="Previous" class="nav-link-hand">
                      <i class="fas fa-caret-left margin-top-3px font-size-24px"></i>
                    </a>
                  </div>

                  <div class="col-md-8 col-sm-4 padding-l-0px padding-right-9px">
                    <div class="date-form">
                      <input class="form-control border-top-0 border-left-0 border-right-0 border-bottom-0px border-radius-2px font-size-24px data-color-new" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedFromDate" [(ngModel)]="SelectedFromDate" ngbDatepicker #d="ngbDatepicker"
                             (ngModelChange)="dataChanged($event)">

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>



                  </div>
                  <div (click)="IncrementDate()" class="col-md-1 margin-top-auto margin-bottom-auto padding-left-6px padding-right-19px decrementhover">
                    <a title="Next" class="nav-link-hand">
                      <i class="fas fa-caret-right margin-top-3px font-size-24px"></i>
                    </a>
                  </div>
                  <!--<div class="col-md-1 padding-left-0px">
                    <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printconsumption()">
                      <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                    </a>
                  </div>-->
                </div>

              </div>
            </div>
            <div class="col-md-4 float-right padding-right-0px padding-l-0px display-inherit">
              <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div class="card-body padding-top-0px">

      <div class="row">
        <div class="col-md-12">
          <div class="table-component">
            <div class="table-responsive overflow-x">


              <table class="table table-striped margin-left-zero"
                     cols="auto,2*,*,*,*,*,*,*">

                <thead class="">
                  <tr>
                    <th class="min-width-24px">
                      #
                    </th>
                    <th class="padding-left-0px">
                      Consumtion No
                    </th>
                    <!--<th class="">
                      PID
                    </th>-->
                    
                    <!--<th class="">
                      Name
                    </th>-->
                    
                    <th class="">
                      Date
                    </th>
                    <th class="">
                      Entry Done By
                    </th>
                    <th class="">
                      Consumed For
                    </th>
                    <th class="">Status</th>
                    <th>Remarks</th>             

                  </tr>
                </thead>

                <tbody class="table-body">
                  <tr *ngFor="let l of CurrentMaterialConsumptionEntries2Controller; let RowIndex = index ">
                    <td class="td-padding-tb">
                      {{RowIndex+1}}
                    </td>
                    <td class="td-padding-tb">
                      <a (click)="Consumptionreceipt(l)" class="nav-link-hand"><i class="far fa-folder-open margin-right-3px folder-color"></i>
                      {{l.EntryCode}}
                      </a>
                    </td>
                    <!--<td class="td-padding-tb"> <a (click)="Consumptionreceipt(l)" class="nav-link-hand"><i class="far fa-folder-open margin-right-3px folder-color"></i>{{l.PatientFormattedCode}}</a></td>

                    <td class=" td-padding-tb">{{l.PatientName}}</td>-->
                    <td class=" td-padding-tb">{{l.EntryDate | date:'MMM-dd-yyyy'}}</td>
                    <td class="td-padding-tb">{{l.EntryUserName}}</td>
                    <td class="td-padding-tb ">{{l.StoreLocationName}}</td>
                    <td class=" td-padding-tb ">{{l.AdjustmentStatus}}</td>
                    <td class="td-padding-tb">{{l.Remarks}}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>


